import React, { useState } from "react";

type ExpandableTaskDescriptionProps = {
  description: string;
};

export const ExpandableTaskDescription = ({ description }: ExpandableTaskDescriptionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if description has multiple paragraph tags
  const paragraphMatches = description.match(/<p[^>]*>/g);
  const hasMultipleParagraphs = paragraphMatches && paragraphMatches.length > 1;

  // Only truncate if there are multiple paragraphs
  const needsTruncation = hasMultipleParagraphs;

  // Create truncated version by showing only the first paragraph
  const getTruncatedDescription = () => {
    if (!needsTruncation) return description;

    // Find the end of the first paragraph
    const firstParagraphEnd = description.indexOf("</p>");
    if (firstParagraphEnd !== -1) {
      return description.substring(0, firstParagraphEnd + 4); // +4 to include '</p>'
    }

    // Fallback: return full description if no closing </p> found
    return description;
  };

  const displayDescription = isExpanded ? description : getTruncatedDescription();

  return (
    <div className="task-description-expandable">
      <div
        dangerouslySetInnerHTML={{ __html: displayDescription }}
        style={{
          fontSize: "14px",
          lineHeight: "1.5",
        }}
      />

      {needsTruncation && (
        <a
          href="#"
          className="mt-2 d-inline-block"
          onClick={(e) => {
            e.preventDefault();
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? "See less" : "See more"}
        </a>
      )}

      <style
        dangerouslySetInnerHTML={{
          __html: `
          .task-description-expandable ul {
            list-style-type: disc;
            margin-left: 1.5rem;
            margin-bottom: 0.5rem;
            margin-top: 0.5rem;
          }
          
          .task-description-expandable ul ul {
            list-style-type: circle;
            margin-left: 1.5rem;
          }
          
          .task-description-expandable ul ul ul {
            list-style-type: square;
            margin-left: 1.5rem;
          }
          
          .task-description-expandable li {
            margin-bottom: 0.5rem;
          }
          
          .task-description-expandable a {
            color: #007bbd;
            fontSize: 14px;
            fontWeight: 500;
            marginTop: 8px;
            cursor: pointer;
            textDecoration: underline;
            
            &:hover {
              color: #00476e;
            }
          }
        `,
        }}
      />
    </div>
  );
};
